import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdjustmentsHomeComponent } from './adjustments/adjustments-home/adjustments-home.component';
import { QuickSearchHomeComponent } from './quick-search-home/quick-search-home.component';





const routes: Routes = [
  {
    path: '',
    component: QuickSearchHomeComponent,
    children: [
      { path: 'home', component: AdjustmentsHomeComponent },
    ]
  },
  {path: 'home', component: AdjustmentsHomeComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class QuickSearchRoutingModule {
  static components = [];
}